import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsGridBlockColumnEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsGridBlockColumnEntity
